<template>
  <div class="margin-subpages document-style">
    <div class="flex-center">
      <div @click="selectMenu('guides')" class="fs-18 fw-700">DOCUMENTS</div>
      <div
        class="cursor-pointer underline mt-12 mb-12 ml-24"
        @click="selectMenu('guides')"
      >
        Guides
      </div>
      <div class="px-10 flex-center">|</div>
      <div class="cursor-pointer underline mt-12 mb-12" @click="drawer = true">
        Menu
      </div>
    </div>
    <div class="line-style mt-12 mb-16"></div>
    <div>
      <div v-if="activeDrawer == 'guides'">
        <div>
          <div class="mt-12 fw-700">My Happily Guides</div>
          <div class="mx-40">
            <div class="fs-20 fw-700 opa-02 mt-32">Insights</div>
            <div class="grid-4-25 ml-32 gap-guide">
              <div>
                <span
                  @click="selectMenu('Insights_Dashboard')"
                  class="cursor-pointer underline"
                  >Dashboard</span
                >
              </div>
              <div>
                <span
                  @click="selectMenu('Insights_Teams_Cohorts')"
                  class="cursor-pointer underline"
                  >Teams & Cohorts</span
                >
              </div>
              <div>
                <span
                  @click="selectMenu('Insights_Managers')"
                  class="cursor-pointer underline"
                  >Managers</span
                >
              </div>
              <div>
                <span
                  @click="selectMenu('Insights_People')"
                  class="cursor-pointer underline"
                  >People</span
                >
              </div>
              <div>
                <span>Report Card</span>
              </div>
            </div>
            <div class="fs-20 fw-700 opa-02 mt-32">Keynote</div>
            <div class="grid-4-25 ml-32 gap-guide">
              <div>
                <span
                  @click="selectMenu('Keynote_Dimension')"
                  class="cursor-pointer underline"
                  >Dimension</span
                >
              </div>
              <div>
                <span
                  @click="selectMenu('Keynote_Talent_Types')"
                  class="cursor-pointer underline"
                  >Talent Types</span
                >
              </div>
              <div>
                <span>Network Type</span>
              </div>
              <div>
                <span>Power Skills</span>
              </div>
            </div>
            <div class="fs-20 fw-700 opa-02 mt-32">Resources</div>
            <div>
              <div class="ml-32 gap-guide grid-resources">
                <div>&nbsp;</div>
                <div class="grid-2-50">
                  <div class="center">ENGLISH</div>
                  <div class="center">THAI</div>
                </div>
              </div>
              <div
                v-for="value in resourcesLink"
                :key="value.name + value.description"
              >
                <div class="ml-32 gap-guide grid-resources">
                  <div class="">
                    <div>{{ value.name }}</div>
                    <div class="fs-14 opa-06">{{ value.description }}</div>
                  </div>
                  <div class="grid-2-50">
                    <div v-if="value.link_en" class="flex-mid">
                      <a
                        :href="value.link_en"
                        target="_blank"
                        :rel="value.name"
                        class="fs-14"
                      >
                        Click
                      </a>
                    </div>
                    <div v-else class="flex-mid">-</div>
                    <div v-if="value.link_th" class="flex-mid">
                      <a
                        :href="value.link_th"
                        target="_blank"
                        :rel="value.name"
                        class="fs-14"
                      >
                        Click
                      </a>
                    </div>
                    <div v-else class="flex-mid">-</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="activeDrawer == 'Insights_Dashboard'">
        <div class="title-custom">Dashboard</div>
        <dashboard-insights @changedMenu="onChangedMenu" />
        <div class="buttom-link">
          <div @click="drawer = true" class="text-link text-menu">Menu</div>
          <div @click="selectMenu('guides')" class="text-link text-left">
            Guides
          </div>
          |
          <div
            @click="selectMenu('Insights_Teams_Cohorts')"
            class="text-link text-right"
          >
            Teams & Cohorts
          </div>
        </div>
      </div>
      <div v-else-if="activeDrawer == 'Insights_Teams_Cohorts'">
        <div class="title-custom">Teams & Cohorts</div>
        <dashboard-team-cohort @changedMenu="onChangedMenu" />
        <div class="buttom-link">
          <div @click="drawer = true" class="text-link text-menu">Menu</div>
          <div
            @click="selectMenu('Insights_Dashboard')"
            class="text-link text-left"
          >
            Dashboard
          </div>
          |
          <div
            @click="selectMenu('Insights_Managers')"
            class="text-link text-right"
          >
            Managers
          </div>
        </div>
      </div>
      <div v-else-if="activeDrawer == 'Insights_Managers'">
        <div class="title-custom">Managers</div>
        <dashboard-managers @changedMenu="onChangedMenu" />
        <div class="buttom-link">
          <div @click="drawer = true" class="text-link text-menu">Menu</div>
          <div
            @click="selectMenu('Insights_Teams_Cohorts')"
            class="text-link text-left"
          >
            Teams & Cohorts
          </div>
          <div
            @click="selectMenu('Insights_People')"
            class="text-link text-right"
          >
          People
          </div>
        </div>
      </div>
      <div v-else-if="activeDrawer == 'Insights_People'">
        <div class="title-custom">People</div>
        <dashboard-people @changedMenu="onChangedMenu" />
        <div class="buttom-link">
          <div @click="drawer = true" class="text-link text-menu">Menu</div>
          <div
            @click="selectMenu('Insights_Managers')"
            class="text-link text-left"
          >
            Managers
          </div>
          <!-- <div @click="selectMenu('Insights_Managers')" class="text-link text-right">Managers</div> -->
        </div>
      </div>
      <div v-else-if="activeDrawer == 'Keynote_Dimension'">
        <div class="title-custom">Dimension</div>
        <keynote-dimension @changedMenu="onChangedMenu"></keynote-dimension>
        <div class="buttom-link">
          <div @click="drawer = true" class="text-link text-menu">Menu</div>
          <!-- <div
            @click="selectMenu('Insights_Teams_Cohorts')"
            class="text-link text-left"
          >
            Teams & Cohorts
          </div> -->
          <div class="ml-auto"></div>
          <div
            @click="selectMenu('Keynote_Talent_Types')"
            class="text-link text-right"
          >
            Talent Types
          </div>
        </div>
      </div>
      <div v-else-if="activeDrawer == 'Keynote_Talent_Types'">
        <div class="title-custom">Talent Types</div>
        <keynote-talent-types
          @changedMenu="onChangedMenu"
        ></keynote-talent-types>
        <div class="buttom-link">
          <div @click="drawer = true" class="text-link text-menu">Menu</div>
          <div
            @click="selectMenu('Keynote_Dimension')"
            class="text-link text-left"
          >
            Dimension
          </div>
          <!-- <div @click="selectMenu('Insights_Managers')" class="text-link text-right">Managers</div> -->
        </div>
      </div>
    </div>
    <el-drawer
      title=" "
      :visible.sync="drawer"
      direction="ltr"
      :with-header="false"
    >
      <div class="px-32 mt-40">
        <div class="title-custom mb-18">
          <div
            @click="selectMenu('guides')"
            class="fs-18 fw-500 cursor-pointer"
          >
            Introduct
          </div>
        </div>
        <el-collapse v-model="activeCollapse">
          <el-collapse-item name="Insights">
            <template slot="title">
              <div class="title-custom">
                <div class="fs-18 fw-500">Insights</div>
              </div>
            </template>
            <div class="container-log documents-in-collapse">
              <div
                @click="selectMenu('Insights_Dashboard')"
                class="header-label m-8 cursor-pointer"
              >
                <div class="fs-16">Dashboard</div>
              </div>
              <div
                @click="selectMenu('Insights_Teams_Cohorts')"
                class="header-label m-8 cursor-pointer"
              >
                <div class="fs-16">Teams & Cohorts</div>
              </div>
              <div
                @click="selectMenu('Insights_Managers')"
                class="header-label m-8 cursor-pointer"
              >
                <div class="fs-16">Managers</div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="Keynote">
            <template slot="title">
              <div class="title-custom">
                <div class="fs-18 fw-500">Keynote</div>
              </div>
            </template>
            <div class="container-log documents-in-collapse">
              <div
                @click="selectMenu('Keynote_Dimension')"
                class="header-label m-8 cursor-pointer"
              >
                <div class="fs-16">Dimension</div>
              </div>
              <div
                @click="selectMenu('Keynote_Talent_Types')"
                class="header-label m-8 cursor-pointer"
              >
                <div class="fs-16">Talent Types</div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  components: {
    dashboardInsights: require("./documents/dashboard-insights").default,
    dashboardTeamCohort: require("./documents/dashboard-team_cohort").default,
    dashboardManagers: require("./documents/dashboard-managers").default,
    dashboardPeople: require("./documents/dashboard-people").default,
    keynoteDimension: require("./documents/keynote-dimension").default,
    keynoteTalentTypes: require("./documents/keynote-talent_types").default,
  },
  name: "documents",
  data() {
    return {
      drawer: false,
      activeDrawer: "guides", // guides
      activeCollapse: "Insights", // Insights
      dimension: [
        {
          quest_id: "-Kgs61AHOnpJ3rfyQr6t",
          category_id: "-KxQjHv0aMgv6TWNWemH",
          name: "Happiness",
          quest_name: "How do you feel today at the office?",
          dimpic: "Happiness@2x",
          characterName: "Harry",
        },
        {
          quest_id: "-Kgn7oxLPPWlbM_ZDc_h",
          category_id: "-KxRdFigA6geGzv2zJHQ",
          name: "Personal Growth",
          quest_name: "How would you rate your opportunities for growth?",
          dimpic: "Personal-Growth@2x",
          characterName: "Polly",
        },
        {
          quest_id: "-L0J5FFsGQYVkfcGujWo",
          category_id: "-KxRwgLlN0DpB0p7al7N",
          name: "Recognition",
          quest_name: "Have you gotten any recognition in the last 7 days?",
          dimpic: "Recognition@2x",
          characterName: "Rain",
        },
        {
          quest_id: "-Kgs549ClADmNQwoNbbG",
          category_id: "-KxRyiIXeDebHreB12mM",
          name: "Relationship with Colleagues",
          quest_name:
            "How would you rate the level of respect colleagues give to each other in your workplace?",
          dimpic: "Rel.Colleagues@2x",
          characterName: "Ron", // Ron & Reef
        },
        {
          quest_id: "-L1FmpFO-v8IZc_B5EB7",
          category_id: "-KxRzHeGK7cuwKtAKQwF",
          name: "Satisfaction",
          quest_name: "Do you feel challenged at work?",
          dimpic: "Satisfaction@2x",
          characterName: "San",
        },
        {
          quest_id: "-L2ycGiBDo3rDGjLNKwW",
          category_id: "-KxRzbMWTgeqpsSbCo_6",
          name: "Ambassadorship",
          quest_name: "Do you see yourself working here one year from now?",
          dimpic: "Ambassadorship@2x",
          characterName: "Amy",
        },
        {
          quest_id: "-L1QWPtZvax_KlJgpNxF",
          category_id: "-KxS-JNn6sNeqTD0KE53",
          name: "Feedback",
          quest_name: "Do you think you get enough feedback?",
          dimpic: "Feedback@2x",
          characterName: "Freddie",
        },
        {
          quest_id: "-L1Qug-PhtzVOR2Dr5q7",
          category_id: "-KxS-e4O2--BrGiRWbEF",
          name: "Relationship with Managers",
          quest_name:
            "In the past 7 days, have you interacted with your manager?",
          dimpic: "Rel.Manager@2x",
          characterName: "Max",
        },
        {
          quest_id: "-L36rxTgLhZTL4mq4SV1",
          category_id: "-KxS05m9KaS70Ai6ps93",
          name: "Wellness",
          quest_name:
            "In the past 7 days, have you felt stressed or overwhelmed at work?",
          dimpic: "Wellness@2x",
          characterName: "Will",
        },
        {
          quest_id: "-LtOL_iR1N-ev2b_8Tmg",
          category_id: "-KxS15s4DhoKSrjs4D7k",
          name: "Company Alignment",
          quest_name:
            "In the past 7 days, have you felt stressed or overwhelmed at work?",
          dimpic: "Company-Alignment@2x",
          characterName: "Coal",
        },
      ],
      resourcesLink: [
        {
          name: "Let's Explore Happily.ai Together",
          description:
            "Welcome to a day with Happily.ai —an end-to-end AI solution that transforms how your organization “works.”",
          link_en:
            "https://www.youtube.com/watch?v=sbMZczGMSiA",
          link_th: "",
        },
        {
          name: "Guidebook for Managers",
          description:
            "PDF - The Guidebook for Managers for more information and tips created for high-performing managers",
          link_en:
            "https://6518315.fs1.hubspotusercontent-na1.net/hubfs/6518315/Customer Success/Materials and Resources/A Playbook for Managers .pdf",
          link_th: "",
        },
        {
          name: "My Happily Walkthrough 2022",
          description: "PDF - ???",
          link_en:
            "https://docs.google.com/presentation/d/1eU7z2-902wWtwChOyOQUyBzaHSnVlMAyBqAlZyUSYUk/edit#slide=id.g13b8f168fcb_0_9",
          link_th:
            "https://docs.google.com/presentation/d/1CrV01qHCodiHeD1Zoe7dDIzSrL87mp6lEmT2083EwBQ/edit?usp=sharing",
        },
        {
          name: "Getting to know Happily.ai",
          description:
            "Youtube - A quick walk-through of the many Happily.ai experiences -- from feedback and recognition, to rewards, insights, and more!",
          link_en: "https://www.youtube.com/watch?v=avr34dwHQFQ",
          link_th: "https://www.youtube.com/watch?v=kuzE6ZK8Y9c",
        },
      ],
    };
  },
  methods: {
    selectMenu(menu) {
      this.drawer = false;
      this.activeDrawer = menu;
    },
    onChangedMenu(menu) {
      this.activeDrawer = menu;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-label {
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  color: #6c30cc;
}

.title-custom {
  color: #000;
  font-size: 20px;
  font-weight: 700;
}
.buttom-link {
  display: flex;
  margin: 64px auto 64px 32px;
  .text-link {
    font-size: 16px;
    text-decoration: underline;
    cursor: pointer;
  }
  .text-left {
    margin-left: auto;
    position: relative;
    padding-left: 24px;
    margin-right: 12px;
    &::before {
      content: "<";
      position: absolute;
      left: 12px;
    }
  }
  .text-right {
    position: relative;
    padding-right: 24px;
    margin-left: 12px;
    &::after {
      content: ">";
      position: absolute;
      right: 12px;
    }
  }
}
.grid-resources {
  display: grid;
  grid-template-columns: 70% 30%;
}
.gap-guide {
  gap: 12px 0;
  padding: 12px 0 0;
}
</style>

<style lang="scss">
.documents-in-collapse {
  .el-collapse-item__header {
    padding-left: 8px;
  }
}
.document-style {
  li {
    margin-top: 24px;
  }
  ul {
    margin-block-start: 16px;
  }
  .container-log {
    line-height: 18px;
    margin-left: 12px;
    position: relative;
    padding: 8px;
    background-color: rgba($color: #eee, $alpha: 0.3);
  }
  .title-list-style {
    font-weight: 700;
    text-transform: capitalize;
    font-size: 18px;
    border-bottom: 1px solid #eee;
    padding: 1px 8px 6px;
    margin-bottom: 2px;
    margin-right: 24px;
  }
  .note-box {
    padding: 12px 24px 12px 40px;
    margin: 12px;
    font-size: 14px;
    color: #222;
    position: relative;
    background-color: rgba($color: #f1f3f4, $alpha: 1);
    width: 86%;
    &:before {
      position: absolute;
      content: "#";
      font-weight: 700;
      top: 7px;
      left: 21px;
      font-size: 20px;
      width: 24px;
      height: 24px;
    }
  }

  .tip-box {
    padding: 12px 24px 12px 40px;
    margin: 12px;
    font-size: 14px;
    color: #5423a2;
    position: relative;
    background-color: rgba($color: #6c30cc, $alpha: 0.1);
    width: 86%;
    &:before {
      position: absolute;
      content: "★";
      top: 10px;
      left: 20px;
      font-size: 15px;
      width: 24px;
      height: 24px;
    }
    .note-header {
      font-weight: 700;
      margin-right: 6px;
    }
  }

  .reference {
    margin-top: 36px;
    > .ref-title {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 4px;
    }
    > .link {
      color: #000;
      margin-left: 24px;
    }
  }

  .link-ref {
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>